import { Color, UniformsUtils } from 'three';
import { fogParsVert, fogVert, fogParsFrag, fogFrag } from './FogReplace.glsl';

export default function fog(material, {
  fogNearColor = new Color(0.20, 0.23, 0.27),
  fogHorizonColor = new Color(0.14, 0.18, 0.22),
  fogDensity = .25,
  fogNoiseSpeed = 100,
  fogNoiseFreq = .092,
  fogNoiseImpact = .00,
  fogCeiling = 24.00001,
  fogFloor = -4.00001,
} = {}) {
  let shader;

  material.onFogTick = clock => {
    if (!shader) return;
    shader.uniforms.time.value = clock.elapsedTime;
  };

  material.onBeforeCompile = value => {
    shader = value;

    shader.vertexShader = shader.vertexShader.replace(
      `#include <fog_pars_vertex>`,
      fogParsVert
    );
    shader.vertexShader = shader.vertexShader.replace(
      `#include <fog_vertex>`,
      fogVert
    );
    shader.fragmentShader = shader.fragmentShader.replace(
      `#include <fog_pars_fragment>`,
      fogParsFrag
    );
    shader.fragmentShader = shader.fragmentShader.replace(
      `#include <fog_fragment>`,
      fogFrag
    );

    shader.uniforms = UniformsUtils.merge([shader.uniforms, {
      fogNearColor: { value: new Color(fogNearColor) },
      fogHorizonColor: { value: new Color(fogHorizonColor) },
      fogNoiseFreq: { value: fogNoiseFreq },
      fogNoiseSpeed: { value: fogNoiseSpeed },
      fogNoiseImpact: { value: fogNoiseImpact },
      fogDensity: { value: fogDensity },
      fogFloor: { value: fogFloor },
      fogCeiling: { value: fogCeiling },
      time: { value: 0 }
    }]);
  };

  return material;
}